import { db } from './firebase';
import { collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, orderBy, Timestamp } from 'firebase/firestore';
import type { CalendarEvent, CalendarEventFormData } from '../types/calendar';

const CALENDAR_COLLECTION = 'calendar-events';

export const calendarService = {
  // 새 이벤트 추가
  addEvent: async (eventData: CalendarEventFormData): Promise<CalendarEvent> => {
    try {
      const docRef = await addDoc(collection(db, CALENDAR_COLLECTION), {
        ...eventData,
        allDay: eventData.allDay || false, // Ensure allDay is boolean
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now(),
      });
      return { id: docRef.id, ...eventData, allDay: eventData.allDay || false, createdAt: Timestamp.now() };
    } catch (error) {
      console.error("Error adding event:", error);
      throw error;
    }
  },

  // 모든 이벤트 가져오기
  getAllEvents: async (): Promise<CalendarEvent[]> => {
    try {
      const q = query(collection(db, CALENDAR_COLLECTION), orderBy('start', 'asc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => {
        const data = doc.data();
        return {
          id: doc.id,
          title: data.title,
          start: data.start,
          end: data.end,
          allDay: data.allDay,
          description: data.description,
          createdAt: data.createdAt,
          updatedAt: data.updatedAt,
        } as CalendarEvent;
      });
    } catch (error) {
      console.error("Error getting all events:", error);
      throw error;
    }
  },

  // 이벤트 수정
  updateEvent: async (id: string, eventData: Partial<CalendarEventFormData>): Promise<void> => {
    try {
      const eventRef = doc(db, CALENDAR_COLLECTION, id);
      await updateDoc(eventRef, {
        ...eventData,
        updatedAt: Timestamp.now(),
      });
    } catch (error) {
      console.error("Error updating event:", error);
      throw error;
    }
  },

  // 이벤트 삭제
  deleteEvent: async (id: string): Promise<void> => {
    try {
      await deleteDoc(doc(db, CALENDAR_COLLECTION, id));
    } catch (error) {
      console.error("Error deleting event:", error);
      throw error;
    }
  },
};
